import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { MemoryAnswersV1 } from '../MemoryAnswersV1';
import { BLOCKS } from '../../shared/memory-map-data';
import { getChapterOrder, getMemoryMap } from '../../shared/memory-map-helpers';
import styles from './ChapterPickSlide.css';

const HEADING = 'Your map is the outline of your memory book';
const DESCRIPTION = 'Your map opens the first three chapters of your memory book. You answer one question at a time, and we write it down in your own voice.';
const PROMPT = 'Where do you want to start?';

function ChapterPickSlide({ id, results, submitTemporaryAnswer, userResponse = {} }) {
    const map = getMemoryMap(results.userResponses);
    const order = getChapterOrder(map);
    const current = typeof userResponse?.chapterIndex === 'number' ? userResponse.chapterIndex : map.top;
    const answers = order.map(index => ({ id: index + 1, text: BLOCKS[index].name }));

    const select = chapterIndex => submitTemporaryAnswer({
        id: chapterIndex + 1,
        questionId: id,
        question: PROMPT,
        text: BLOCKS[chapterIndex].name,
        chapterIndex
    });

    useEffect(() => {
        select(current);
    }, []);

    return (
        <section className={styles.form}>
            <div className={styles.text}>
                <h1 className={styles.heading}>{HEADING}</h1>
                <p className={styles.description}>{DESCRIPTION}</p>
            </div>
            <p className={styles.prompt}>{PROMPT}</p>
            <MemoryAnswersV1
                answers={answers}
                selectedId={current + 1}
                onSelect={answer => () => select(answer.id - 1)}
                isWhite
            />
        </section>
    );
}

ChapterPickSlide.propTypes = {
    id: PropTypes.number.isRequired,
    results: PropTypes.shape({ userResponses: PropTypes.array }).isRequired,
    submitTemporaryAnswer: PropTypes.func.isRequired,
    userResponse: PropTypes.object
};

export {
    ChapterPickSlide
};
